/** Fiat codes supported by MoonPay buy widget (from GET /v3/currencies, type=fiat). */
export const MOONPAY_SUPPORTED_FIATS = new Set([
  'aud',
  'brl',
  'cad',
  'chf',
  'cop',
  'czk',
  'dkk',
  'dop',
  'egp',
  'eur',
  'gbp',
  'hkd',
  'idr',
  'ils',
  'jod',
  'kes',
  'kwd',
  'lkr',
  'mxn',
  'ngn',
  'nok',
  'nzd',
  'omr',
  'pen',
  'pln',
  'ron',
  'sek',
  'thb',
  'try',
  'twd',
  'usd',
  'vnd',
  'zar',
]);

export function isMoonPaySupportedFiat(currency: string): boolean {
  return MOONPAY_SUPPORTED_FIATS.has(currency.trim().toLowerCase());
}
